<template>
  <div class="details-component">
    <div class="details-component__header" v-on:click="toggleSection">
      <h1 class="header">{{ $t('end_user.parking_spots') }}</h1>
      <div class="details-component__header_right">
        <div :class="!showSection ? toggleIconDown : toggleIconUp" />
      </div>
    </div>
    <div v-show="showSection" class="section-content-container">
      <div class="parking-spots-map">
        <img src="~assets/wise-map.png" class="wise-img wise-desktop" />
        <img src="~assets/wise-map-mobile.png" class="wise-img wise-mobile" />
        <div class="parking-spots" v-for="item in parkingSpots.state.parkingSpots.data">
          <div :class="`paloma map-tooltip-${mapTooltipsOrder.indexOf(item.id) + 1}`">
            <div v-if="mapTooltipsOrder.includes(item.id)" :class="`map-tooltip-container `">
              <div>{{ item.code }}</div>
              <div>
                <div class="sessions-container">
                  <div class="occupancy-details-container sessions-count">
                    <div class="sessions-count-icon" />{{ item.active_sessions }}
                  </div>
                  <div class="occupancy-details-container max-sessions">
                    <div class="max-sessions-icon" />{{ item.max_sessions }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="locations-container">
        <div class="parking-spot-container locations-title">
          All locations
        </div>
        <div class="parking-spots" v-for="item in parkingSpots.state.parkingSpots.data">
          <div class="parking-spot-container">
            <div class="parking-spot-data">
              <div class="item-code-container">
                <div class="gar" />
                <div class="item-code">{{ item.code }}</div>
              </div>
              <div class="item-address">{{ item.address }}</div>
            </div>
            <div class="sessions-container flex-col">
              <div class="occupancy-details-container sessions-count">
                <div class="sessions-count-icon" />{{ item.active_sessions }}
              </div>
              <div class="occupancy-details-container max-sessions">
                <div class="max-sessions-icon" />{{ item.max_sessions }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import parkingSpots from '../../store/modules/users/parkingSpots';

export default {
  components: {
  },
  data() {
    return {
      parkingSpots,
      showSection: false,
      toggleIconDown: 'icon icon-bl-arrow-down',
      toggleIconUp: 'icon icon-bl-arrow-up',
      mapTooltipsOrder: process.env.NODE_ENV === 'production' ? [605, 615, 635] : [
        451, 450, 449,
      ],
    };
  },
  mounted() {
    this.fetchParkingSpots();
  },
  methods: {
    toggleSection() {
      this.showSection = !this.showSection;
    },
    fetchParkingSpots() {
      this.$store.dispatch('users/parkingSpots/fetch').then(() => {
      });
    },
    computed: Object.assign(mapGetters({
      parkingSpots: 'users/parkingSpots/parkingSpots'
    })),
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/app.scss';

.item-code-container {
  display: flex;
  gap: 6px;
  align-items: center;
}

.wise-desktop {
  display: none;
}

.item-code {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}

.item-address {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.parking-spots-map {
  height: 45vh;
  position: relative;
}

.locations-title {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.wise-img {
  width: 100%;
  height: 100%;
}

.map-tooltip-container {
  background-color: white;
  position: absolute;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 4px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 500;
  line-height: normal;
  width: 250px;
  top: -27px;
  left: -100px;
}

.map-tooltip-1 {
  top: 15%;
  left: 34%;
}

.map-tooltip-2 {
  top: 60%;
  left: 24%;
}

.map-tooltip-3 {
  top: 73%;
  right: 30%;
}

.paloma {
  height: 16px;
  width: 16px;
  position: absolute;
  background: url('~icons/paloma.svg') left center no-repeat;
}

.parking-spots-list {
  list-style: none;
}

.icon {
  width: 28px !important;
  height: 28px !important;
}

.parking-spot-container {
  border-bottom: 1px solid var(--Neutral-05, #F2F3F3);
  background: var(--Neutral-White, #FFF);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
}

h1 {
  font-size: larger;
}

.occupancy-details-container {
  height: 24px;
  display: flex;
  gap: 4px;
  align-items: center;
  justify-content: space-between;
  padding: 4px 5px;
  border-radius: 6px;
}

.sessions-container {
  display: flex;
  align-items: center;
  gap: 4px
}

.sessions-count {
  background-color: #1EE8CA;
}

.sessions-count-icon {
  height: 16px;
  padding: 6px 8px;
  background: url('~icons/park-free-16.svg') left center no-repeat;
}

.parking-spot-data {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex-grow: 1;
}

.max-sessions {
  background-color: #FFD0D0;
}

.max-sessions-icon {
  height: 16px;
  padding: 6px 8px;
  background: url('~icons/park-occupied-16.svg') left center no-repeat;
}

.park-place-16 {
  width: 18px;
  height: 18px;
  background: url('~icons/park_place_16.svg') left center no-repeat;
}

.gar {
  width: 27px;
  height: 18px;
  background: url('~icons/gar.svg') left center no-repeat;
}

@media screen and (min-width: 750px) {
  .locations-container {
    width: 50%
  }

  .parking-spots-map {
    width: 50%
  }

  .parking-spot-container {
    gap: 48px;
  }

  .section-content-container {
    display: flex;
    background-color: #FFF;
    gap: 10px;
  }

  .parking-spot-container {
    padding: 16px 18px;
  }

  .item-code {
    font-size: 16px;
  }

  .item-address {
    font-size: 14px;
  }

  .flex-col {
    flex-direction: column;
  }

  .parking-spots-map {
    order: 2;
    height: 482px;
  }

  .map-tooltip-1 {
    left: 34%;
    top: 15%
  }

  .map-tooltip-2 {
    left: 24%;
    top: 62%;
  }

  .map-tooltip-3 {
    right: 30%;
    top: 75%
  }

  .park-place-16 {
    width: 22px;
    height: 22px;
  }

  .gar {
    height: 22px;
  }
}

@media screen and (min-width: 1200px) {
  .wise-desktop {
    display: block;
  }

  .wise-mobile {
    display: none;
  }

  .locations-container {
    width: 45%
  }

  .parking-spots-map {
    width: 55%
  }

  .flex-col {
    flex-direction: row;
  }

  .map-tooltip-container {
    width: 280px;
  }

  .map-tooltip-1 {
    left: 34.5%;
  }

  .map-tooltip-2 {
    top: 66%;
    left: 28.5%;
  }

  .map-tooltip-3 {
    top: 80%;
    right: 41%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/end-user/ParkingSpots.vue